<template>
  <b-tab title="Album Art" lazy>
    <b-form-group>
      <b-row>
        <b-col md="4">
          <b-img :src="getImg" alt="Album Art" rounded fluid></b-img>
          <br />
          <b-button
            v-if="artSrc"
            block
            variant="link"
            class="text-danger mt-2"
            @click="deleteArt"
          >
            <span key="lang_btn_delete_art">Delete Album Art</span>
          </b-button>
        </b-col>
        <b-col md="8">
          <b-form-group label-for="edit_form_art">
            <template v-slot:label>
              <span key="lang_btn_replace_art">Replace Album Cover Art</span>
            </template>

            <b-form-file
              ref="art"
              id="edit_form_art"
              accept="image/*"
              @input="uploadNewArt"
            ></b-form-file>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </b-tab>
</template>

<script>
// import axios from 'axios';
import { DISPATCH_UPDATE, DISPATCH_DELETE } from "@/store/action-types";
export default {
  name: "MediaFormAlbumArt",
  props: {
    albumArtSrc: String,
    albumArtUrl: String,
  },
  data() {
    return {
      artSrc: this.albumArtSrc,
    };
  },

  computed: {
    getImg() {
      return this.artSrc || require("@/assets/logo.svg");
    },
  },

  methods: {
    uploadNewArt() {

        if (this.artSrc !== '') {
            this.artSrc = '';
        }
      const input = this.$refs.art;
      const files = input.files;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$store
            .dispatch(DISPATCH_UPDATE, {
              url: this.albumArtUrl,
              data: { art: e.target.result },
            })
            .then((res) => {
                this.artSrc = res.data
            })
            
        };
        reader.readAsDataURL(files[0]);
      }
    },

    deleteArt() {
      this.$store
        .dispatch(DISPATCH_DELETE, { url: this.albumArtUrl })
        .then(() => {
          this.artSrc = '';
          this.$refs.art.reset();

        })
        .catch(() => {
           this.artSrc = '';
           this.$refs.art.reset();

        });
    },

  },
};
</script>
